import { ToggleActivityStateFilter } from "components/filters/ToggleActivityStateFilter";
import React from "react";
import { Filter } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { SelectEnumInput } from "../../../components/inputs/SelectEnumInput";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import { CompanyCustomerType } from "../../../entities";

export const CompaniesFilter = (props) => (
	<Filter {...props}>
		<ToggleActivityStateFilter source="activity_state" defaultValue={null} alwaysOn key={"activity_state"}/>
		<TextInputEx debounceTime={750} source="_query" alwaysOn />
		<TextInputEx debounceTime={750} source="full_name" />
		<TextInputEx debounceTime={750} source="short_name" />
		<TextInputEx debounceTime={750} source="email" />
		<TextInputEx debounceTime={750} source="phone" />
		<SelectEnumInput debounceTime={750} source="type" enumObj={CompanyCustomerType} enumName="company-type" />
		<TextInputEx debounceTime={750} source="guid" />
	</Filter>
);
